<template>
  <div class="home">
    <div id="banner">
      <swiper class="swiper" ref="mySwiper" v-if="bannerList.length" :options="swiperOption">
        <swiper-slide  v-for="(v, i) in bannerList" :key="i">
        <a class="banner-item"  :href="v.targetUrl||'###'" :target="v.targetUrl?'_blank':''">
          <img :src="v.imgUrl"  @error="imgError('/img/fileimg.png')">
        </a>
        </swiper-slide>
        
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- <div class="swiper-button-prev swiper-button-white hidden-xs-only" slot="button-prev"></div>
        <div class="swiper-button-next swiper-button-white hidden-xs-only" slot="button-next"></div> -->
      </swiper>
    </div>
    <div id="gy_project">
      <div class="header-title" style="width:99.2%">
        <h1>项目介绍</h1>
        <div class="more" @click="goPage('/project/1242169895796736/')">更多></div>
      </div>
      <div class="project-list project-mobile pro-index" style="justify-content: flex-start">
            <div @click="goProjectList(v)" class="project-item" :class="{'border-right': i !== projectList.length-1 && (i+1)%3 !==0,'border-0':i === projectList.length-1}" v-for="(v, i) in projectList" :key="i">
              <img class="bg-img" :src="v.imgUrl || '/a'" @error="imgError('/img/fileimg.png')">
              <div style="flex:1">
                <h2 style="font-weight:400">{{v.cnName}}</h2>
                <div style="color:#999999;" class="subTitle txt-line-4">{{v.described}}</div>
              </div>
            </div>
      </div>
    </div>
    <div class="content-wrap">
      <div class="header-title" style="border-bottom: none;margin-bottom: 0;">
        <h1>使命愿景</h1>
      </div>
    </div>
    
    <div id="donate_wrap">
      <img class="bg-img" src="../assets/middleBg.jpg" alt="">
      <div class="donate-shade-wrap">
        <div class="donate-shade"></div>
        <div class="donate-hander">
          <div class="donate-hander-item active">
            <h2>理念</h2>
            <div>
              <span>感恩</span><span>奉献</span><span>博爱</span><span>济世</span>
            </div>
          </div>
          <div class="donate-hander-item active">
            <h2>宗旨</h2>
            <div>
              <span>大爱无疆</span><span>回报社会</span><span>普济予民</span>
            </div>
          </div>
          <div class="donate-hander-item">
            <h2>愿景</h2>
            <div>
              <span>让爱唤醒责任</span><span>让爱唤醒善行</span><span>让爱持续流动</span>
            </div>
          </div>
        </div>
        <div id="donate_list_wrap">
          <h2 id="donate_list_title">
            捐赠支出详情
          </h2>
          <div id="donate_list">
            <div class="donate-list" :class="{active: donateList.length > 7}">
              <div class="donate-item" v-for="(v, i) in donateList" :key="i">
                <div class="title txt-line-1">{{v.name}}</div>
                <div class="money">¥ {{v.money}}</div>
                <div class="date">{{v.donationTime}}</div>
              </div>
            </div>
            <div class="donate-list active" v-if="donateList.length > 7">
              <div class="donate-item" v-for="(v, i) in donateList" :key="i">
                <div class="title txt-line-1">{{v.name}}</div>
                <div class="money">¥ {{v.money}}</div>
                <div class="date">{{v.donationTime}}</div>
              </div>
            </div>
          </div>
          <div id="donate_footer"><span>{{donationYear}}年捐赠支出总额</span> <span class="donate-text">{{money}}</span>元</div>
        </div>
      </div>
    </div>
    <!-- <h1 class="home-title">
      同心战疫
      <span class="sub-title">伸出一双手 让爱心变希望</span>
    </h1> -->
    <div class="content-wrap battle-wrap">
      <div class="header-title">
        <h1>同心战疫</h1>
        <div class="more" @click="goPage('/battle/1281628712452096/1281944140890112')">更多></div>
      </div>
      
    </div>
    
    <div class="news-wrap">
      <div class="news-list-item-wrap border-right">
        <div class="news-list-item" @click="toArticle(v)" :class="{'border-0': index === outbreakList.length-1 ||  index === 2}" v-show="index < 3" v-for="(v,index) in outbreakList" :key="index">
          <div class="news-list-item-img">
            <img class="bg-img" :src="v.imgUrl || '/a'"  @error="imgError('/img/newimg.png')">
          </div>
          <div class="news-list-item-text">
            <div class="title txt-line-4">{{v.title}}</div>
            <div class="subTitle txt-line-2">{{v.described  ? v.described : ''}}</div>
          </div>
        </div>
      </div>
      <div class="news-list-trends hidden-xs-only">
         <div @click="toArticle(v)" class="new-trends-item" v-show="i>=3&&i<=7" :class="{'border-bottom': i!==outbreakList.length-1}" v-for="(v, i) in outbreakList" :key="i">
          <div class="title txt-line-2">{{v.title}}</div>
          <div class="described txt-line-2">{{v.described}}</div>
         </div>
      </div>
    </div>
    <div class="content-wrap" style="background: #f2f2f2">
      <div class="header-title about-title">
        <h1>关于我们</h1>
        <div class="more" @click="goPage('/about/102/')">更多></div>
      </div>
    </div>
    <div id="about_us">
      <div class="about-us hidden-xs-only">
        <div class="about-col" @click="toAbout">
          <h2>{{describedName}}</h2>
          <p class="about-txt">{{described}}</p>
        </div>
        <div class="about-col about-cols">
          <div class="inner-border">
            <img class="bg-img" src="../assets/about.jpg" >
          </div>
          
        </div>
      </div>
      <div id="about_us_xs">
        <p class="about-txt">
          {{described}}
        </p>
        <img class="bg-img" src="../assets/about.jpg" >
      </div>
    </div>
    <div class="content-wrap" style="background: #fff;padding-top: 0px;">
      <div class="header-title" style="margin:36px 0 0 0">
        <h1>合作伙伴</h1>
      </div>
    </div>
    
    <div id="partner" class="hidden-xs-only">
     <swiper class="swiper" ref="mySwiper" :options="swiperOptions" v-if="partnersList.length">
        <swiper-slide style="display:flex;flex-wrap:wrap;" class="swiper-item" v-for="(item,i) in partnersList" :key="i">
              <div class="parter-content" :class="{'margin-0': (i+1)%8===0}" v-for="(v, i) in item" :key="i">
                 <a :href="v.targetUrl" target="_blank">
                    <img style="object-fit:contain" class="bg-img" :src="v.imgUrl">
                 </a>
              </div>
        </swiper-slide>
        <div v-if="partnersList.length>=2" style="color:#808080;font-weight:bold;" class="swiper-button-prev  hidden-xs-only" slot="button-prev"></div>
        <div v-if="partnersList.length>=2" style="color:#808080;font-weight:bold;" class="swiper-button-next  hidden-xs-only" slot="button-next"></div> 
      </swiper>
    </div>
    <!-- <div class="partner-phone">
      <swiper class="swiper" ref="mySwiper" :options="swiperOption" v-if="partnersPhoneList.length">
        <swiper-slide style="display:flex;flex-wrap:wrap;" v-for="(item,index) in partnersPhoneList" :key="index">
              <div class="parter-content" :class="{'border-right': (i+1)%2!==0}" v-for="(v, i) in item" :key="i">
                  <div class="parter-img">
                    <a :href="v.targetUrl" target="_blank">
                      <img style="object-fit:contain" class="bg-img" :src="v.imgUrl">
                    </a>
                  </div>
              </div>
            </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      
     </div> -->
    <div class="partner-phone">
      <swiper class="swiper swipers" style="position:relative;" ref="mySwiper" :options="swiperOption" v-if="partnersPhoneList.length">
        <swiper-slide class="swiper-item"  v-for="(item,index) in partnersPhoneList" :key="index">
              <div class="parter-content" v-for="(v, i) in item" :key="i">
                  <div class="parter-img">
                    <a :href="v.targetUrl" target="_blank">
                      <img style="object-fit:contain" class="bg-img" :src="v.imgUrl">
                    </a>
                  </div>
              </div>
        </swiper-slide>
        <!-- <div class="swiper-pagination" slot="pagination"></div> -->
        <div style="color:#808080;font-weight:bold;" class="swiper-button-prev" slot="button-prev"></div>
        <div style="color:#808080;font-weight:bold;" class="swiper-button-next" slot="button-next"></div> 
        
      </swiper>
     </div>
  </div>
</template>

<script>
import {getBanner, getColumns, getDonation, getStory, getPartners} from '@/api/home'
import {imgError} from '@/assets/utility.js'
export default {
  name: 'Home',
  data() {
    return {
      bannerList: [],
      projectList: [],
      middleBg: '',
      donateList: [],
      donationYear: '',
      money: 0,
      outbreakList: [],
      described: '',
      describedName: '',
      partnersList: [],
      partnersPhoneList: [],
      reContents: null,
      swiperOption: { 
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          clickable: true,
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptions: { 
        loop: true,
        autoplay: false,
        pagination: {
          clickable: true,
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  mounted() {
    this.$store.commit('setCurrentMenuI', 0)
    getBanner().then(res => {
      if (res) {
        this.bannerList = res.list
        this.middleBg = res.middle.imgUrl
        this.swiperOption.loop = res.list.length > 1
      }
    })
    getColumns('1242169895796736').then(res => {
      if(res) {
        this.projectList = res[0].subList
      }
    })
    getDonation().then(res => {
      if(res) {
        this.donateList = res.list
        this.donationYear = res.set.donationYear
        this.money = (res.set.money - 0).toLocaleString('en-US')
      }
    })
    getStory().then(res => {
      if(res) {
        this.outbreakList = res
      }
    })
    getColumns('102').then(res => {
      if(res) {
        this.described = res[0].described
        this.describedName = res[0].cnName
      }
    })
    getPartners().then(res => {
      if(res) {
        this.partnersList = this.handleData(res,8)
        if(this.partnersList.length>=2){
          this.swiperOptions.autoplay = {
            delay: 5000,
            disableOnInteraction: false,
          }
        }
        this.partnersPhoneList = this.handleData(res,3)
      }
    })
  },
  methods: {
    goProjectList(pData) {
      this.$router.push(`/project/1242169895796736/list/${pData.colId}`)
    },
    toArticle(pData) {
      this.$router.push(`/article/${pData.id}`)
    },
    toAbout() {
      this.$router.push('/about/102/')
    },
    aaa() {
      console.log(this.$refs.aaaa)
    },
    goPage (url) {
      this.$router.push(url);
    },
    handleData (data,num) {
      let result = [];
      let chunk = num;
      
      for (let i = 0, j = data.length; i < j; i += chunk) {
          result.push(data.slice(i, i + chunk));
      }
      return result
    },
    imgError (url) {
      imgError(url)
    }
  }
}
</script>

<style lang="scss" scoped>
  #banner {
    position: relative;
    overflow: hidden;
    background-color: #fff;
    .swiper {
      height: 100%;
    }
    .banner-item {
      position: relative;
      display: block;
      width: 100%;
      height: 100%;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover
      }
    }
    .toggle-btn {
      position: absolute;
      top: 0;
      bottom: 0;
      display: block;
      margin: auto;
      font-size: 65px;
      width: 65px;
      height: 65px;
      color: #ffffff;
      cursor: pointer;
      z-index: 10;
    }
    .toggle-btn.last {
      left: rem(43);
    }
    .toggle-btn.next {
      right: rem(43);
    }
  }
  .border-0 {
    border-bottom: none!important;
  }
  .content-wrap {
    padding: 0 rem(75);
  }
  #gy_project {
    padding: 0 rem(75); //92
    //height: rem(860); // 950
    .gy-wrap {
      display: flex;
      justify-content: space-between;
      .gy-item {
        position: relative;
        width: rem(526);
        height: rem(471);
        text-align: center;
        overflow: hidden;
        border-right: 1px solid #bfbfbf;
        
        //border-radius: rem(48);
        //box-shadow: 2px 2px 5px #cccccc;
        background-color: #ffffff;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover
        }
        h2 {
          position: absolute;
          width: 100%;
          z-index: 1;
        }
        .shade-div {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          animation: 1s fadeInOut;
          background-color: rgba(#fff, .9);
          .ds-btn {
            position: absolute;
            left: 0;
            right: 0;
            bottom: rem(120);
            display: block;
            margin: auto;
            width: rem(148);
            height: rem(49);
            border-radius: rem(25);
            line-height: rem(49);
            text-align: center;
            color: #fff;
            background-color: #b50627;
          }
        }
      }
    }
  }
  #donate_wrap {
    position: relative;
    .bg-img {
      position: absolute;
      height: rem(1045);
    }
    .donate-shade-wrap {
      position: relative;
      top: 0;
      box-sizing: border-box;
      padding: 0 rem(66);
      width: 100%;
      .donate-shade {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: rem(1045);
        background-color: rgba(#ffffff, 0.7);
      }
      .donate-hander {
        position: relative;
        display: flex;
        justify-content: space-around;
        padding-top: rem(130);
        padding-bottom: rem(66);
        z-index: 1;
        .donate-hander-item {
          box-sizing: border-box;
          padding: 0 13px;
          width: rem(596);
          min-height: rem(148);
          text-align: center;
          h2 {
            margin: 0;
            font-weight: 400;
            color: $main-color;
          }
          span {
            display: inline-block;
            color: #000;
          }
        }
        .donate-hander-item.active {
          border-right: 1px solid #bfbfbf;
        }
      }
      #donate_list_wrap {
        position: relative;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        padding: rem(35) rem(75);
        left: 0;
        right: 0;
        //max-width: 1101px;
        overflow: hidden;
        //border-radius: rem(48);
        box-shadow: 2px 2px 5px #cccccc;
        background-color: #ffffff;
        #donate_list_title {
          margin: 0;
          padding-bottom: rem(20);
          text-align: center;
          font-size: rem(60);
          border-bottom: 2px solid $main-color;
        }
        #donate_list {
          flex: 1;
          margin-bottom: rem(85);
          overflow: hidden;
          .donate-list {
            .donate-item {
              display: flex;
              color: #848484;
              .title {
                flex: 3;
              }
              .money {
                flex: 1;
              }
              .date {
                flex: 1;
                text-align: right;
              }
            }
          }
          .donate-list.active {
            animation: 26s rowup linear infinite normal;
          }
        }
        #donate_footer {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          line-height: rem(85);
          text-align: center;
          font-size: rem(22);
          color: #ffffff;
          background-color: $main-color;
          span {
            margin-right: 2px;
          }
          .donate-text {
            font-size: rem(40);
            font-family: Times New Roman;
          }
        }
      }
    }
  }
  .outbreak-item {
    position: relative;
    margin-bottom: rem(106);
    height: rem(584);
    .outbreak-item-bg {
      position: absolute;
      width: rem(1686);
      right: 0;
      height: 100%;
      border-radius: rem(48) 0 0 0;
      background-color: #e9eaea;
    }
    .outbreak-item-bg.active {
      left: 0;
      right: auto;
      border-radius: 0 0 rem(48) 0;
      background-color: #fff;
    }
    .content {
      position: absolute;
      right: rem(170);
      width: rem(634);
      height: 100%;
      color: #606060;
      h2 {
        margin: rem(28) 0;
        padding: rem(58) 0;
        font-size: rem(33);
        line-height: rem(50);
        max-height: rem(158);
        vertical-align: middle;
        font-weight: 400;
        border-bottom: 2px solid #606060;
      }
      p {
        margin: 0;
        height: rem(174);
        font-size: rem(20);
      }
    }
    .content.active {
      left: rem(170);
      right: auto;
    }
    img {
      position: absolute;
      left: rem(90);
      bottom: 0;
      width: rem(793);
      height: rem(518);
      border-radius: rem(48);
      object-fit: cover;
    }
    img.active {
      top: 0;
      left: auto;
      bottom: auto;
      right: rem(90);
    }
  }
  #about_us {
    padding:rem(50) rem(75) rem(50) rem(75);
    //background-color: #fff;
    background-color: #f2f2f2;
    .about-us {
      display: flex;
      height: rem(700);
      .about-col {
        h2 {
          font-weight: 400;
        }
        flex: 1;
        padding: rem(200) rem(75) rem(100) 0;
        border-right: 1px solid #bfbfbf;
        .about-txt {
          margin-bottom: rem(40);
          padding: rem(30) 0;
          font-size: rem(20);
          //border-bottom: 3px solid #606060;
          color: #808080;
        }
        // img {
        //   border-radius: rem(48);
        // }
      }
      .about-cols {
        padding: rem(100) 0 rem(100) rem(100);
        margin-top: 0;
        position: relative;
        border-right: none;
        .inner-border {
          border: 3px solid #287429;
          // width: 100%;
          // height: 100%;
          position: relative;
          left: -(rem(40));
          top: -(rem(40));
          img{
            position: relative;
            left: rem(40);
            top:rem(40);
          }
        }
      }
    }
  }
  #partner {
    display: flex;
    //justify-content: space-between;
    flex-wrap: wrap;
    background: #fff;
    
    .partner-item {
      position: relative;
      display: block;
      box-sizing: border-box;
      text-align: center;
      box-shadow: 2px 2px 5px #cccccc;
      background-color: #fff;
      margin-right: 10px;
      img {
        display: inline-block;
        object-fit: contain;
      }
    }
  }
  @keyframes rowup {
    0% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
    100% {
      -webkit-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }
  }
  .header-title {
      display: flex;
      justify-content: space-between;
      border-top: 7px solid #01663e;
      border-bottom: 1px solid #bfbfbf;
      h1{
        margin: 0;
      }
      .more{
        color: #00653E;
        cursor: pointer;
      }
    }
  @media only screen and (min-width: 768px) {
    #banner {
      height: rem(700); /// 773
    }
    .header-title {
      display: flex;
      justify-content: space-between;
      margin-top: rem(66);
      border-top: 7px solid #01663e;
      height:rem(110);
      line-height: rem(110);
      border-bottom: 1px solid #bfbfbf;
      margin-bottom: 32px;
      h1{
        margin: 0;
      }
      .more{
        color: #00653E;
      }
    }
    #gy_project {
      .project-item{
        line-height: 30px;
      }
    }
    .gy-item {
      h2 {
        bottom: 0;
        font-size: rem(36);
        color: #fff;
        transition: bottom .8s;
      }
      .shade-div {
        display: none;
      }
    }
    .gy-item:hover {
      h2 {
        bottom: rem(200);
        color: #000;
      }
      h2::before {
        content: '';
        display: block;
        margin: 0 auto;
        width: 30px;
        border: 1px solid #999;
      }
      h2::after {
        content: '伸出一双手让爱心变希望';
        display: block;
        font-size: rem(17);
      }
      .shade-div {
        display: block;
      }
    }
    .donate-hander-item {
      h2 {
        font-size: rem(48);
      }
      span {
        margin-right: rem(24);
        font-size: rem(24);
      }
    }
    #donate_list_wrap {
      height: rem(613);
    }
    .donate-item {
      padding-top: rem(20);
      font-size: rem(20);
    }
    #donate_footer {
      height: rem(85);
    }
    #outbreak_wrap {
      display: none;
    }
    #about_us_xs {
      display: none;
    }
    #partner {
      position: relative;
      padding: 32px rem(75) rem(100) rem(75);
      //justify-content: space-between;
      .partner-item {
        margin: 0 rem(30) rem(30) rem(30);
        padding: rem(20) 0;
        width: rem(320);
        height: rem(190);
        //border-radius: rem(16);
        img {
          width: rem(239);
          height: rem(150);
        }
      }
      .margin-0 {
        margin-right: 0;
      }
    }
     .new-trends-item {
       padding-top:0;
     }
     .swiper-item {
       .parter-content:nth-child(1) {
         margin-left:rem(35)
       }
     }
     .partner-phone {
       display: none
     }
     .parter-content {
       width: rem(210); // 255
       height: 120px;
       .border-right{
         border-right: 1px solid #bfbfbf;
       }
       //margin-right: rem(10);
       .parter-img {
          padding: rem(40) 0;
          height: rem(136);
          //margin-right: rem(65);
          border-bottom: 1px solid #bfbfbf;
       }
       .bg-img{
          transform: scale(.9);
          width: 100%;
          height: 120px;
       }
     }
     .battle-wrap{
       margin-top: rem(130)
     }
     .about-title {
        margin-bottom:0;
      }
  }
  @media only screen and (max-width: 768px) {
    #banner {
      height: 4.81rem;
    }
    .header-title {
        display: flex;
        height: 45px;
        line-height: 45px;
        margin-top: 25px;
        border-top: 3px solid #01663e;
        h1 {
          font-size: .5rem;
        }
        .more{
          font-size: .24rem;
        }
      }
      .about-title {
        margin-top:0;
      }
    #gy_project {
      .project-list {
      .project-item {
          width: 100%;
          display:flex;
          flex-wrap: wrap;
          border-bottom:1px solid #bfbfbf;
          padding-bottom: .44rem;
          line-height: 18px;
          h2{
            margin: 0;
            color: #333;
            padding-bottom: 20px;
            font-size: .3rem;
          }
          .bg-img{
            width: 3.5rem;
            margin-right: 21px;
          }
          .subTitle  {
            font-size: .24rem;
          }
        }
        .border-0 {
          border-bottom: none;
        }
      }
      
    }
    .home {
      .battle-wrap {
          margin-bottom:.5rem;
          padding-top: .5rem;
          
        }
      .news-wrap {
        padding: rem(75) rem(75) 0 rem(75);
      }
      .news-list-item {
        width: 100%;
        display:flex;
        flex-wrap: wrap;
        border-bottom:1px solid #bfbfbf;
        padding-bottom: .5rem;
        .news-list-item-img {
          margin-bottom: 0;
        }
        .bg-img{
          width: 3.5rem;
          margin-right: 21px;
        }
        .news-list-item-text {
          width: 2.5rem;
          .title {
            font-weight: 600;
          }
          .subTitle  {
            font-size: .24rem;
          }
        }
      }
    }
    .gy-item {
      h2 {
        bottom: 0;
        font-size: .36rem;
        color: #fff;
      }
      .shade-div {
        display: none;
      }
    }
    .donate-hander-item {
      h2 {
        font-size: .36rem;
      }
      span {
        margin-right: .03rem;
        font-size: .18rem;
      }
    }
    #donate_list_wrap {
      height: 3.53rem
    }
    .donate-item {
      padding-top: 0.05rem;
      font-size: 0.18rem;
    }
    #donate_footer {
      height: .49rem;
    }
    #outbreak_wrap {
      display: block;
    }
    .outbreak-xs-item {
      margin-bottom: .9rem;
      padding: 0 .575rem;
      img {
        width: 100%;
        height: 2.9rem;
        border-radius: .25rem;
        object-fit: cover;
      }
      h2 {
        font-size: .3rem;
        font-weight: 400;
        color: #333;
      }
      .sub-title-wrap {
        display: flex;
        align-items:center;
        .sub-title {
          flex: 1;
          font-size: .25rem;
          color: #979797;
        }
        .btn-wrap {
          flex: 1;
          text-align: right;
          .detail-btn {
            display: inline-block;
          }
        }
      }
    }
    #about_us_xs {
      padding: 0 0 .5rem 0;
      img {
        //height: 2.9rem;
        height: 5rem;
        //border-radius: .25rem;
      }
      .about-txt {
        margin-bottom: .5rem;
        font-size: .3rem;
        line-height: .5rem;
        color:#999999;
      }
      .detail-btn {
        float: right;
      }
    }
    #partner {
      padding: 0 0 1rem .57rem;
      .partner-item {
        margin: 0 .3rem .3rem .3rem;
        padding: .25rem 0;
        width: 2.6rem;
        height: 1.5rem;
        border-radius: .16rem;
        img {
          width: 1.89rem;
          height: 1rem;
        }
      }
    }
    // .partner-phone {
    //     position: relative;
    //     display: flex;
    //     flex-wrap: wrap;
    //     padding: .53rem rem(75);
    //     background: #fff;
        
    //     .border-right {
    //       border-right: 1px solid #bfbfbf;
    //     }
    //     .parter-content{
    //       margin-right: .2rem;
    //     }
    //     .parter-img {
    //       padding: .3rem;
    //       margin-right: .2rem;
    //       border-bottom: 1px solid #bfbfbf;
         
    //       img {
    //          width: 2.3rem;
    //          height: 1.5rem;
    //       }
    //     }
    //  }
    // .swiper-pagination {
    //   bottom: 0px!important;
    // }
    .swipers {
      padding: .3rem 0 .3rem .8rem;
    }
    .partner-phone {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        padding: .53rem rem(75);
        background: #fff;
        .border-right {
          border-right: 1px solid #bfbfbf;
        }
        .parter-content{
          margin-right: .2rem;
        }
        .swiper-item {
          display:flex;
          flex-wrap:wrap;
          .parter-content:nth-child(3){
          margin-right: 0;
        }
        }
        .parter-img {
          //padding: .3rem;
          margin-right: .1rem;
          img {
             width: 1.5rem; // 2.3rem
             height: 1.5rem;
          }
        }
     } 
  }
</style>
